var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "product-search-view" } },
      [
        _c(
          "portal",
          { attrs: { to: "ads-container-top" } },
          [
            _c("ci-suggested-external-content", {
              attrs: { type: "display", id: _vm.adIds.header },
            }),
          ],
          1
        ),
        _c(
          "portal",
          { attrs: { to: "ads-container-right" } },
          [
            _c("ci-suggested-external-content", {
              attrs: { type: "skyscraper", id: _vm.adIds.skyscraper },
            }),
            _c("ci-suggested-external-content", {
              attrs: { type: "sidebar", id: _vm.adIds.sidebar_2nd },
            }),
          ],
          1
        ),
        _c("ci-registration-modal", {
          attrs: {
            "gating-banner-location": "fund_search",
            "onboarding-type": "gating-banner",
            "return-button-text":
              "ui.components.users.onboarding.register.back_to_fund_search",
            "soft-gating": true,
          },
        }),
        _c(
          "ais-instant-search",
          {
            attrs: {
              "search-client": _vm.searchClient,
              "index-name": _vm.indexName,
              searchFunction: _vm.searchFunction,
              routing: _vm.routing,
              future: { preserveSharedStateOnUnmount: true },
            },
          },
          [
            _c("ais-configure", {
              attrs: {
                filters: _vm.searchConfig.filters,
                hitsPerPage: _vm.searchConfig.hitsPerPage,
                typoTolerance: "min",
              },
            }),
            _c("div", { staticClass: "ci-content-header" }, [
              _c(
                "div",
                { staticClass: "ci-content-header__inner" },
                [
                  _c("h1", {
                    staticClass: "h2 m-0",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("ui.views.products.fundsearch.header.title")
                      ),
                    },
                  }),
                  _c("div", {
                    staticClass: "p mb-4",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t(
                          "ui.views.products.fundsearch.header.description"
                        )
                      ),
                    },
                  }),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("ci-ais-search", {
                          staticClass: "mb-3",
                          attrs: {
                            label: _vm.$t(
                              "ui.views.products.fundsearch.header.filters.title"
                            ),
                            clearable: true,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-6 col-lg col-xl" },
                      [
                        _c("ci-ais-select", {
                          staticClass: "mb-3",
                          attrs: {
                            id: "ais-focus_asset",
                            attribute: "focus_asset",
                            label: _vm.$t(
                              "ui.shared.products.attributes.focus_asset"
                            ),
                            limit: 200,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-sm-6 col-lg col-xl" },
                      [
                        _c("ci-ais-select", {
                          staticClass: "mb-3",
                          attrs: {
                            id: "ais-focus_region",
                            attribute: "focus_region",
                            label: _vm.$t(
                              "ui.shared.products.attributes.focus_region"
                            ),
                            limit: 200,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-auto col-lg-auto col-xl-auto d-flex align-items-center",
                      },
                      [
                        _c(
                          "ci-ais-toggle",
                          {
                            staticClass: "mb-3",
                            attrs: {
                              attribute: "has_product_attachments",
                              label: _vm.$t(
                                "ui.views.products.fundsearch.header.filters.has_product_attachments"
                              ),
                            },
                          },
                          [
                            _c("div", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: {
                                    customClass: "tooltip-xl text-left",
                                    html: true,
                                  },
                                  expression:
                                    "{ customClass: 'tooltip-xl text-left', html: true }",
                                },
                              ],
                              staticClass:
                                "mdi mdi-information mx-1 text-muted",
                              attrs: {
                                title: _vm.$t(
                                  "ui.views.products.fundsearch.header.filters.has_product_attachments_tooltip"
                                ),
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md col-lg-12 col-xl-auto d-flex align-items-center",
                      },
                      [
                        _c("ci-ais-sfdr-refinement-list", {
                          attrs: { attribute: "sustainable_preference" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("ais-current-refinements", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ items, createURL }) {
                          return [
                            items.length > 0
                              ? _c("div", { staticClass: "d-flex pt-4" }, [
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "ais-CurrentRefinements-list",
                                    },
                                    [
                                      _vm._l(items, function (item) {
                                        return _c(
                                          "li",
                                          {
                                            key: item.attribute,
                                            staticClass:
                                              "ais-CurrentRefinements-item mb-1 mr-1 text-nowrap",
                                          },
                                          [
                                            item.refinements.some(
                                              (r) => r.type === "numeric"
                                            ) || item.refinements.length > 1
                                              ? _c("span", {
                                                  staticClass:
                                                    "ais-CurrentRefinements-label",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.getRefinementLabelTranslation(
                                                        item,
                                                        true
                                                      )
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._l(
                                              item.refinements,
                                              function (refinement, index) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: [
                                                      refinement.attribute,
                                                      refinement.type,
                                                      refinement.value,
                                                      refinement.operator,
                                                    ].join(":"),
                                                    staticClass:
                                                      "ais-CurrentRefinements-category btn-cursor",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return item.refine(
                                                          refinement
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    item.refinements.some(
                                                      (r) =>
                                                        r.type === "disjunctive"
                                                    )
                                                      ? [
                                                          _c("span", {
                                                            staticClass:
                                                              "ais-CurrentRefinements-categoryLabel font-weight-semi",
                                                            domProps: {
                                                              textContent:
                                                                _vm._s(
                                                                  _vm.getRefinementLabelTranslation(
                                                                    item,
                                                                    false,
                                                                    index
                                                                  )
                                                                ),
                                                            },
                                                          }),
                                                        ]
                                                      : [
                                                          _c("span", {
                                                            staticClass:
                                                              "ais-CurrentRefinements-categoryLabel",
                                                            class: {
                                                              "font-weight-semi":
                                                                !item.refinements.some(
                                                                  (r) =>
                                                                    r.type ===
                                                                    "numeric"
                                                                ),
                                                            },
                                                            domProps: {
                                                              textContent:
                                                                _vm._s(
                                                                  _vm.labelFor(
                                                                    refinement
                                                                  )
                                                                ),
                                                            },
                                                          }),
                                                        ],
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "ais-CurrentRefinements-delete ml-2",
                                                      },
                                                      [_vm._v("✕")]
                                                    ),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      }),
                                      _c("ais-clear-refinements", {
                                        staticClass:
                                          "d-flex align-items-center ml-3",
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({
                                                canRefine,
                                                refine,
                                                createURL,
                                              }) {
                                                return [
                                                  _c("a", {
                                                    staticClass:
                                                      "ais-ClearRefinements-button",
                                                    class: {
                                                      canRefine: "d-none",
                                                    },
                                                    attrs: { type: "reset" },
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "ui.views.products.fundsearch.header.filters.clear_filters"
                                                        )
                                                      ),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        _vm.clearAllRefinements()
                                                        refine()
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    2
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "a",
                    {
                      staticClass:
                        "flex-center w-100 pt-2 pb-2 btn-cursor font-weight-semi",
                      attrs: { id: "filter-toggle" },
                      on: { click: _vm.toggleFilters },
                    },
                    [
                      _c("span", {
                        staticClass: "mdi mdi-chevron-down mr-2",
                        class: { "mdi-rotate-180": _vm.showAllFilters },
                      }),
                      _vm.showAllFilters
                        ? _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "ui.views.products.fundsearch.header.filters.hide_filters"
                                )
                              ),
                            },
                          })
                        : _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "ui.views.products.fundsearch.header.filters.show_filters"
                                )
                              ),
                            },
                          }),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showAllFilters,
                          expression: "showAllFilters",
                        },
                      ],
                      attrs: { id: "fundsearch-filter" },
                    },
                    [
                      _c("div", { staticClass: "row pt-4" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "fundsearch-filter__column first-filter-column col-12 col-md-6 col-xl-5 pr-md-4",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "filter-group",
                                class: _vm.showFilterGroups.performance
                                  ? "show-filter-group"
                                  : "hide-filter-group",
                              },
                              [
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "h5 filter-group-title mb-4 d-flex",
                                    on: {
                                      click: function ($event) {
                                        _vm.showFilterGroups.performance =
                                          !_vm.showFilterGroups.performance
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "flex-grow-1",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "ui.views.products.fundsearch.header.filters.headlines.performance"
                                          )
                                        ),
                                      },
                                    }),
                                    _c("span", {
                                      staticClass:
                                        "mdi mdi-chevron-up flex-shrink-0 d-md-none",
                                    }),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "filter-group-content" },
                                  [
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-performance",
                                        attribute: "performance.performance",
                                        options: _vm.periodOptions.performance,
                                        label:
                                          _vm.$t(
                                            "ui.views.products.fundsearch.header.filters.performance.performance"
                                          ) + " in %",
                                      },
                                    }),
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-maximum_draw_down",
                                        attribute:
                                          "ratios_fund_currency.maximum_draw_down",
                                        options:
                                          _vm.periodOptions.maximum_draw_down,
                                        label:
                                          _vm.$t(
                                            "ui.views.products.fundsearch.header.filters.ratios_fund_currency.maximum_draw_down"
                                          ) + " in %",
                                      },
                                    }),
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-volatility",
                                        attribute: "ratios_euro.volatility",
                                        options: _vm.periodOptions.volatility,
                                        label:
                                          _vm.$t(
                                            "ui.views.products.fundsearch.header.filters.ratios_euro.volatility"
                                          ) + " in %",
                                      },
                                    }),
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-sharpe_ratio",
                                        attribute: "ratios_euro.sharpe_ratio",
                                        options: _vm.periodOptions.sharpe_ratio,
                                        label: _vm.$t(
                                          "ui.views.products.fundsearch.header.filters.ratios_euro.sharpe_ratio"
                                        ),
                                        min: -30,
                                        max: 70,
                                      },
                                    }),
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-tracking_error",
                                        attribute: "ratios_euro.tracking_error",
                                        options:
                                          _vm.periodOptions.tracking_error,
                                        label:
                                          _vm.$t(
                                            "ui.views.products.fundsearch.header.filters.ratios_euro.tracking_error"
                                          ) + " in %",
                                        min: 0,
                                        max: 150,
                                      },
                                    }),
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-correlation_coefficient",
                                        attribute:
                                          "ratios_euro.correlation_coefficient",
                                        options:
                                          _vm.periodOptions
                                            .correlation_coefficient,
                                        label: _vm.$t(
                                          "ui.views.products.fundsearch.header.filters.ratios_euro.correlation_coefficient"
                                        ),
                                      },
                                    }),
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-information_ratio",
                                        attribute:
                                          "ratios_euro.information_ratio",
                                        options:
                                          _vm.periodOptions.information_ratio,
                                        label: _vm.$t(
                                          "ui.views.products.fundsearch.header.filters.ratios_euro.information_ratio"
                                        ),
                                        min: -1,
                                        max: 1,
                                      },
                                    }),
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-beta",
                                        attribute: "ratios_euro.beta",
                                        options: _vm.periodOptions.beta,
                                        label: _vm.$t(
                                          "ui.views.products.fundsearch.header.filters.ratios_euro.beta"
                                        ),
                                        min: -10,
                                        max: 40,
                                      },
                                    }),
                                    _c("ci-ais-range-with-period", {
                                      staticClass: "mb-4",
                                      attrs: {
                                        id: "ais-treynor_ratio",
                                        attribute: "ratios_euro.treynor_ratio",
                                        options:
                                          _vm.periodOptions.treynor_ratio,
                                        label: _vm.$t(
                                          "ui.views.products.fundsearch.header.filters.ratios_euro.treynor_ratio"
                                        ),
                                        min: -60,
                                        max: 60,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-6 col-xl-7 pl-md-4 pl-xl-2",
                          },
                          [
                            _c("div", { staticClass: "row h-100" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fundsearch-filter__column second-filter-column col-12 col-xl-6 px-xl-4",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "filter-group",
                                      class: _vm.showFilterGroups
                                        .investment_areas
                                        ? "show-filter-group"
                                        : "hide-filter-group",
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "h5 filter-group-title mb-4 d-flex",
                                          on: {
                                            click: function ($event) {
                                              _vm.showFilterGroups.investment_areas =
                                                !_vm.showFilterGroups
                                                  .investment_areas
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "flex-grow-1",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "ui.views.products.fundsearch.header.filters.headlines.investment_areas"
                                                )
                                              ),
                                            },
                                          }),
                                          _c("span", {
                                            staticClass:
                                              "mdi mdi-chevron-up flex-shrink-0 d-md-none",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "filter-group-content" },
                                        [
                                          _c("ci-ais-select", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              id: "ais-sectors",
                                              attribute:
                                                "portfolio.sectors.name",
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.portfolio.sectors.name"
                                              ),
                                              limit: 200,
                                            },
                                          }),
                                          _c("ci-ais-select", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              id: "ais-countries",
                                              attribute:
                                                "portfolio.countries.name",
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.portfolio.countries.name"
                                              ),
                                              limit: 200,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("hr", {
                                    staticClass:
                                      "divider invisible lg d-none d-mb-block",
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "filter-group",
                                      class: _vm.showFilterGroups.fees
                                        ? "show-filter-group"
                                        : "hide-filter-group",
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "h5 filter-group-title mb-4 d-flex",
                                          on: {
                                            click: function ($event) {
                                              _vm.showFilterGroups.fees =
                                                !_vm.showFilterGroups.fees
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "flex-grow-1",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "ui.views.products.fundsearch.header.filters.headlines.fees"
                                                )
                                              ),
                                            },
                                          }),
                                          _c("span", {
                                            staticClass:
                                              "mdi mdi-chevron-up flex-shrink-0 d-md-none",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "filter-group-content" },
                                        [
                                          _c("h3", {
                                            staticClass: "h6",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "ui.views.products.fundsearch.header.filters.subscription_fee_net"
                                                ) + " in %"
                                              ),
                                            },
                                          }),
                                          _c("ci-ais-range-with-period", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              attribute: "subscription_fee_net",
                                            },
                                          }),
                                          _c("h3", {
                                            staticClass: "h6",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "ui.views.products.fundsearch.header.filters.sum_ongoing_charges"
                                                ) + " in %"
                                              ),
                                            },
                                          }),
                                          _c("ci-ais-range-with-period", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              attribute: "sum_ongoing_charges",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("hr", {
                                    staticClass:
                                      "divider invisible lg d-none d-mb-block",
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "filter-group",
                                      class: _vm.showFilterGroups.types
                                        ? "show-filter-group"
                                        : "hide-filter-group",
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "h5 filter-group-title mb-4 d-flex",
                                          on: {
                                            click: function ($event) {
                                              _vm.showFilterGroups.types =
                                                !_vm.showFilterGroups.types
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "flex-grow-1",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "ui.views.products.fundsearch.header.filters.headlines.types"
                                                )
                                              ),
                                            },
                                          }),
                                          _c("span", {
                                            staticClass:
                                              "mdi mdi-chevron-up flex-shrink-0 d-md-none",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "filter-group-content" },
                                        [
                                          _c("ci-ais-select", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              id: "ais-distribution_type",
                                              attribute:
                                                "distribution_type.type",
                                              label: _vm.$t(
                                                "ui.shared.products.attributes.distribution_type"
                                              ),
                                            },
                                          }),
                                          _c("ci-ais-toggle", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              attribute: "savings_plan",
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.savings_plan"
                                              ),
                                            },
                                          }),
                                          _c("ci-ais-toggle", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              attribute: "is_etf",
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.is_etf"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fundsearch-filter__column third-filter-column col-12 col-xl-6 pl-xl-4",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "filter-group",
                                      class: _vm.showFilterGroups.ratings
                                        ? "show-filter-group"
                                        : "hide-filter-group",
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "h5 filter-group-title mb-4 d-flex",
                                          on: {
                                            click: function ($event) {
                                              _vm.showFilterGroups.ratings =
                                                !_vm.showFilterGroups.ratings
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "flex-grow-1",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "ui.views.products.fundsearch.header.filters.headlines.ratings"
                                                )
                                              ),
                                            },
                                          }),
                                          _c("span", {
                                            staticClass:
                                              "mdi mdi-chevron-up flex-shrink-0 d-md-none",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "filter-group-content" },
                                        [
                                          _c(
                                            "ci-ais-numeric-menu",
                                            {
                                              attrs: {
                                                attribute: "sri",
                                                options: 7,
                                                operation: "max",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex" },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "ui.views.products.fundsearch.header.filters.sri"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _c("span", {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName: "v-b-tooltip",
                                                        value: {
                                                          customClass:
                                                            "tooltip-xl text-left",
                                                          html: true,
                                                        },
                                                        expression:
                                                          "{ customClass: 'tooltip-xl text-left', html: true }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "mdi mdi-information ml-2 text-muted",
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "ui.shared.global.tooltips.sri_html"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "ci-ais-numeric-menu",
                                            {
                                              attrs: {
                                                attribute: "rating.fww",
                                                options: 5,
                                                icons: "true",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex" },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "ui.views.products.fundsearch.header.filters.rating.fww"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _c("span", {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName: "v-b-tooltip",
                                                        value: {
                                                          customClass:
                                                            "tooltip-xl text-left",
                                                          html: true,
                                                        },
                                                        expression:
                                                          "{ customClass: 'tooltip-xl text-left', html: true }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "mdi mdi-information ml-2 text-muted",
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "ui.shared.global.tooltips.fww_rating_html"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "ci-ais-numeric-menu",
                                            {
                                              attrs: {
                                                attribute: "rating.morningstar",
                                                options: 5,
                                                icons: "true",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex" },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "ui.views.products.fundsearch.header.filters.rating.morningstar"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _c("span", {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName: "v-b-tooltip",
                                                        value: {
                                                          customClass:
                                                            "tooltip-xl text-left",
                                                          html: true,
                                                        },
                                                        expression:
                                                          "{ customClass: 'tooltip-xl text-left', html: true }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "mdi mdi-information ml-2 text-muted",
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "ui.shared.global.tooltips.morningstar_rating_html"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c("hr", {
                                    staticClass:
                                      "divider invisible lg d-none d-mb-block",
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "filter-group",
                                      class: _vm.showFilterGroups.misc
                                        ? "show-filter-group"
                                        : "hide-filter-group",
                                    },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          staticClass:
                                            "h5 filter-group-title mb-4 d-flex",
                                          on: {
                                            click: function ($event) {
                                              _vm.showFilterGroups.misc =
                                                !_vm.showFilterGroups.misc
                                            },
                                          },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "flex-grow-1",
                                            domProps: {
                                              textContent: _vm._s(
                                                _vm.$t(
                                                  "ui.views.products.fundsearch.header.filters.headlines.misc"
                                                )
                                              ),
                                            },
                                          }),
                                          _c("span", {
                                            staticClass:
                                              "mdi mdi-chevron-up flex-shrink-0 d-md-none",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "filter-group-content" },
                                        [
                                          _c("ci-ais-select", {
                                            staticClass: "mb-3",
                                            attrs: {
                                              id: "ais-fund_company",
                                              attribute: "fund_company",
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.fund_company"
                                              ),
                                              limit: 200,
                                            },
                                          }),
                                          _c("ci-ais-select", {
                                            staticClass: "mb-3",
                                            attrs: {
                                              id: "ais-currency",
                                              attribute: "currency",
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.currency"
                                              ),
                                              limit: 200,
                                            },
                                          }),
                                          _c("ci-ais-select", {
                                            staticClass: "mb-3",
                                            attrs: {
                                              id: "ais-tranche",
                                              attribute: "tranche",
                                              "transform-items":
                                                _vm.translateSelectItems,
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.tranche.label"
                                              ),
                                            },
                                          }),
                                          _c("ci-ais-select", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              id: "ais-volume_range",
                                              attribute: "volume_range",
                                              "transform-items":
                                                _vm.sortAndTranslateSelectItems,
                                              label: _vm.$t(
                                                "ui.shared.products.attributes.volume"
                                              ),
                                            },
                                          }),
                                          _c("ci-ais-select", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              id: "ais-minimum_initial_investment_range",
                                              attribute:
                                                "minimum_initial_investment_range",
                                              "transform-items":
                                                _vm.sortAndTranslateSelectItems,
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.minimum_initial_investment"
                                              ),
                                            },
                                          }),
                                          _c("ci-ais-select", {
                                            staticClass: "mb-4",
                                            attrs: {
                                              id: "ais-age_range",
                                              attribute: "age_range",
                                              "transform-items":
                                                _vm.sortAndTranslateSelectItems,
                                              label: _vm.$t(
                                                "ui.views.products.fundsearch.header.filters.launch_date"
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _c(
              "div",
              { staticClass: "container-mw ci-content__body" },
              [
                _c("ais-menu", {
                  attrs: { attribute: "partner_ids" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ items }) {
                        return [
                          _c(
                            "ci-sales-banner",
                            { attrs: { "focus-asset": _vm.focusAsset } },
                            [
                              _c("ci-partners", {
                                attrs: {
                                  items: items,
                                  searchClient: _vm.searchClient,
                                  lastSearchState: _vm.lastSearchState,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("ais-hits", {
                  staticClass: "mb-3",
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ items }) {
                        return [
                          items.length > 0
                            ? _c(
                                "div",
                                {
                                  ref: "results",
                                  staticClass:
                                    "ci-card ci-section ci-content-padding",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "w-100" },
                                    [
                                      _c("div", { staticClass: "row mb-3" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-sm-8 col-lg-9 d-flex align-items-center",
                                          },
                                          [
                                            _c("ais-stats", {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      hitsPerPage,
                                                      nbPages,
                                                      nbHits,
                                                      page,
                                                      processingTimeMS,
                                                      query,
                                                    }) {
                                                      return [
                                                        _c("h2", {
                                                          staticClass:
                                                            "h4 mb-md-0",
                                                          domProps: {
                                                            textContent: _vm._s(
                                                              _vm.$t(
                                                                "ui.views.products.fundsearch.results",
                                                                {
                                                                  count: nbHits,
                                                                }
                                                              )
                                                            ),
                                                          },
                                                        }),
                                                        _c("ci-button", {
                                                          staticClass:
                                                            "reference-tab",
                                                          class: {
                                                            show: _vm.showReferenceTab,
                                                          },
                                                          attrs: {
                                                            icon: "mdi-arrow-down",
                                                            variant:
                                                              "filled-primary",
                                                            label: _vm.$t(
                                                              "result_count",
                                                              { count: nbHits }
                                                            ),
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.scrollToResults,
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 col-sm-4 col-lg-2 offset-lg-1",
                                          },
                                          [
                                            _c("ais-sort-by", {
                                              staticClass: "d-lg-none",
                                              attrs: {
                                                items: _vm.sortingOptions,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function ({
                                                      items,
                                                      currentRefinement,
                                                      refine,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "ci-fe-wrapper",
                                                          {
                                                            attrs: {
                                                              id: "sorting",
                                                              value:
                                                                currentRefinement,
                                                            },
                                                          },
                                                          [
                                                            _c("v-select", {
                                                              staticClass:
                                                                "ci-form--input no-label",
                                                              attrs: {
                                                                searchable: false,
                                                                clearable: false,
                                                                options: items,
                                                                value:
                                                                  _vm.currentSortOption,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return refine(
                                                                      $event.value
                                                                    )
                                                                  },
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "open-indicator",
                                                                      fn: function ({
                                                                        attributes,
                                                                      }) {
                                                                        return [
                                                                          _c(
                                                                            "span",
                                                                            _vm._b(
                                                                              {
                                                                                staticClass:
                                                                                  "mdi mdi-chevron-down text-lg",
                                                                              },
                                                                              "span",
                                                                              attributes,
                                                                              false
                                                                            )
                                                                          ),
                                                                        ]
                                                                      },
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("ais-sort-by", {
                                        attrs: { items: _vm.sortingOptions },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ refine }) {
                                                return [
                                                  _c(
                                                    "ci-product-collection-table",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "ci-is-in-viewport",
                                                          rawName:
                                                            "v-ci-is-in-viewport",
                                                          value: "result_table",
                                                          expression:
                                                            "'result_table'",
                                                        },
                                                      ],
                                                      attrs: {
                                                        id: "product-search-result-table",
                                                        items:
                                                          _vm.mapProducts(
                                                            items
                                                          ),
                                                        "primary-key": "id",
                                                        "show-default-static-fields": false,
                                                        "static-fields":
                                                          _vm.fields,
                                                        "product-click-handler":
                                                          _vm.trackClick,
                                                        "ranking-click-handler":
                                                          _vm.trackClick,
                                                      },
                                                      on: {
                                                        "performance-period-changed":
                                                          function ($event) {
                                                            return _vm.handlePerformancePeriodChange(
                                                              $event,
                                                              refine
                                                            )
                                                          },
                                                      },
                                                    }
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex justify-content-center mt-3 mt-md-4",
                                                    },
                                                    [
                                                      _c("ais-pagination", {
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                currentRefinement,
                                                                nbPages,
                                                                pages,
                                                                isFirstPage,
                                                                isLastPage,
                                                                refine,
                                                                createURL,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    [
                                                                      _c(
                                                                        "ci-pagination",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "current-page":
                                                                                currentRefinement,
                                                                              "number-of-pages":
                                                                                nbPages,
                                                                              pages:
                                                                                pages,
                                                                              callback:
                                                                                refine,
                                                                              onSwitch:
                                                                                _vm.onPaginationChange,
                                                                            },
                                                                        }
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : [
                                _c("ci-emptystate", {
                                  staticClass: "ci-card",
                                  attrs: {
                                    search: true,
                                    "search-query": _vm.query,
                                    "locale-path": "products.search",
                                  },
                                }),
                              ],
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("ci-product-comparison-cart", {
          ref: "comparisonCart",
          attrs: { autoShowVariable: "SearchComparisonBarShown" },
          on: { "comparison-started": _vm.trackComparisonStarted },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }